<div class="dialog-container">
    <div class="dialog-header">
        <div class="header-title">
            <span *ngIf="!isEditing">Create Estimate</span>
            <span *ngIf="isEditing && !isSplitting">Edit Estimate</span>
            <span *ngIf="isEditing && isSplitting">Split Estimate</span>
        </div>
        <button mat-button class="close-button-container" (click)="close()" disableRipple="true">
            <mat-icon>clear</mat-icon>
        </button>
    </div>

    <div class="dialog-content" [class.with-list]="showEstimatesList">
        <div class="estimates-list" *ngIf="showEstimatesList">
            <div class="list-header">Project Estimates</div>

            <div class="estimates-container" *ngIf="!loadingEstimates">
                <div class="estimate-item"
                     *ngFor="let est of projectEstimates; trackBy: trackEntityById"
                     [class.current]="est.id === estimate?.id"
                     (click)="editEstimate(est)">
                    <div class="estimate-info">
                        <div class="estimate-date">{{ est.txnDate | date: 'MM/dd/yyyy' }}</div>
                        <div class="estimate-amount">${{ est.amount | number:'1.2-2' }}</div>
                    </div>
                    <div class="estimate-actions">
                        <mat-icon *ngIf="est.userModified" class="flag-icon" title="User Modified">edit</mat-icon>
                        <mat-icon *ngIf="est.parentId" class="flag-icon" title="Split Estimate">call_split</mat-icon>
                        <mat-icon *ngIf="est.createdManually && !est.parentId" class="flag-icon" title="Created Manually">add_circle</mat-icon>
                        <button mat-icon-button class="action-button" *ngIf="est?.qbTxnId" (click)="openInQb(est); $event.stopPropagation()" title="Open in QuickBooks">
                            <mat-icon>open_in_new</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="no-estimates" *ngIf="projectEstimates.length === 0">
                    No estimates found
                </div>
            </div>

            <div class="estimates-loading" *ngIf="loadingEstimates">
                <mat-spinner diameter="30"></mat-spinner>
            </div>
        </div>

        <div class="form-content">
            <div *ngIf="!isSplitting">
                <div class="form-row">
                    <label>Project</label>
                    <p-dropdown [(ngModel)]="selectedProject" [options]="projects" optionLabel="name" [filter]="true"
                                filterBy="name,number" placeholder="Select a project" [showClear]="false" appendTo="body"
                                (onChange)="onProjectChange()">
                        <ng-template let-project pTemplate="item">
                            {{ project.name }}
                        </ng-template>
                        <ng-template let-project pTemplate="selectedItem">
                            {{ project.name }}
                        </ng-template>
                    </p-dropdown>
                </div>

                <div class="form-row">
                    <label>Date</label>
                    <p-calendar [(ngModel)]="txnDate" dateFormat="mm/dd/yy" [showIcon]="true" appendTo="body"></p-calendar>
                </div>

                <div class="form-row" *ngIf="!isSplitting">
                    <label *ngIf="!(!estimate?.parentId || estimate?.percentage == null)">Amount and Percentage</label>
                    <label *ngIf="!estimate?.parentId || estimate?.percentage == null">Amount</label>
                    <div class="split-inputs-row">
                        <input type="text" [(ngModel)]="amountDisplay" (input)="onAmountInput($event)" (blur)="onAmountBlur()"
                               (focus)="onAmountFocus()" placeholder="$0.00" class="amount-input split-input">
                        <input type="text" [(ngModel)]="percentageDisplay" (input)="onPercentageInput($event)"
                               (blur)="onPercentageBlur()" (focus)="onPercentageFocus()" placeholder="0.00%"
                               class="amount-input split-input" *ngIf="!(!estimate?.parentId || estimate?.percentage == null)">
                    </div>
                    <span class="help-text" *ngIf="estimate?.parentId || estimate?.percentage != null">Original estimate: ${{ estimate.originalAmount | number:'1.2-2' }}</span>
                </div>
            </div>

            <div *ngIf="isSplitting && estimate">
                <div class="form-row">
                    <label>Original Estimate</label>
                    <div class="readonly-value">
                        {{ estimate.projectName }}<br>
                        Amount: ${{ estimate.amount | number:'1.2-2' }}<br>
                        Date: {{ estimate.txnDate | date:'MM/dd/yyyy' }}
                    </div>
                </div>

                <div class="form-row">
                    <label>New Estimate Date</label>
                    <p-calendar [(ngModel)]="splitDate" dateFormat="mm/dd/yy" [showIcon]="true"
                                appendTo="body"></p-calendar>
                </div>

                <div class="form-row">
                    <label>Percentage and Amount for New Estimate</label>
                    <div class="split-inputs-row">
                        <input type="text" [(ngModel)]="splitPercentageDisplay" (input)="onSplitPercentageInput($event)"
                               (blur)="onSplitPercentageBlur()" (focus)="onSplitPercentageFocus()" placeholder="0.00%"
                               class="amount-input split-input">
                        <input type="text" [(ngModel)]="splitAmountDisplay" (input)="onSplitAmountInput($event)"
                               (blur)="onSplitAmountBlur()" (focus)="onSplitAmountFocus()" placeholder="$0.00"
                               class="amount-input split-input">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="dialog-footer">
        <button mat-button (click)="cancel()" class="cancel-button">Cancel</button>
        <button mat-button class="delete-button" (click)="deleteEstimate()"
                *ngIf="isEditing && estimate?.createdManually && !isSplitting">
            <mat-icon>delete</mat-icon>
            Delete
        </button>
        <button mat-button class="split-toggle-button" (click)="toggleSplitMode()"
                *ngIf="isEditing && !estimate?.parentId && !isSplitting">
            <mat-icon>call_split</mat-icon>
            Split Estimate
        </button>
        <button mat-button (click)="split()" *ngIf="isSplitting" [disabled]="saving" class="save-button">
            <mat-spinner *ngIf="saving" diameter="20" class="button-spinner"></mat-spinner>
            <span *ngIf="!saving">Split</span>
        </button>
        <button mat-button (click)="save()" *ngIf="!isSplitting" [disabled]="saving" class="save-button">
            <mat-spinner *ngIf="saving" diameter="20" class="button-spinner"></mat-spinner>
            <span *ngIf="!saving">{{ isEditing ? 'Update' : 'Create' }}</span>
        </button>
    </div>
</div>

